const amplitude = require('@amplitude/unified');

/**
 * Export the root Spark application.
 */
module.exports = {
    el: '#app',

    /**
     * Holds the timestamp for the last time we updated the API token.
     */
    lastRefreshedApiTokenAt: null,

    /**
     * The application's data.
     */
    data: {
        user: Spark.state.user,
        teams: Spark.state.teams,
        currentTeam: Spark.state.currentTeam,
        loadingNotifications: false,
        notifications: null,
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        const self = this;

        if (Spark.userId && Spark.usesApi) {
            this.refreshApiTokenEveryFewMinutes();
        }

        Bus.$on('updateUser', function() {
            console.log('a');
            self.getUser();
        });

        Bus.$on('updateTeams', function() {
            console.log('b');
            self.getTeams();
            self.getCurrentTeam();
        });

        Bus.$on('updateTeam', function() {
            console.log('c');
            self.getCurrentTeam();
            // self.getTeam();
        });

        if (Spark.userId) {
            console.log(Spark.userId);
            amplitude.setUserId(Spark.userId);
            const identifyEvent = new amplitude.Identify();
            if (this.user && this.user.email) {
                identifyEvent.set('email', this.user.email);
            }
            if (this.currentTeam) {
                identifyEvent.set('team_id', this.currentTeam.id);
                identifyEvent.set('team_name', this.currentTeam.name);
                identifyEvent.set('team_type', this.currentTeam.team_type);
            }
            amplitude.identify(identifyEvent);
        }
    },

    methods: {

        /**
         * Refresh the current API token every few minutes.
         */
        refreshApiTokenEveryFewMinutes() {
            this.lastRefreshedApiTokenAt = moment();

            setInterval(() => {
                this.refreshApiToken();
            }, 240000);

            setInterval(() => {
                if (moment().diff(this.lastRefreshedApiTokenAt, 'minutes') >= 5) {
                    this.refreshApiToken();
                }
            }, 5000);
        },

        /**
         * Refresh the current API token.
         */
        refreshApiToken() {
            this.lastRefreshedApiTokenAt = moment();

            axios.put('/spark/token');
        },

        /**
         * Get the current user of the application.
         */
        getUser() {
            axios.get('/user/current').then((response) => {
                this.user = response.data;
            });
        },

        /**
         * Get the current team list.
         */
        getTeams() {
            axios.get('/settings/teams').then((response) => {
                this.teams = response.data;
            });
        },

        /**
         * Get the current team.
         */
        getCurrentTeam() {
            axios
                .get(`/settings/teams/current`)
                .then(response => {
                    console.log(response.data);
                    this.currentTeam = response.data;
                })
                .catch(response => {
                    //
                });
        },


        /**
         * Show an alert informing the user their support request was sent.
         */
        showSupportRequestSuccessMessage() {
            swal({
                title: 'Got It!',
                text: 'We have received your message and will respond soon!',
                type: 'success',
                showConfirmButton: false,
                timer: 2000,
            });
        },
    },

    computed: {
        /**
         * The number of unread announcements.
         */
        unreadAnnouncementsCount() {
            return 0;
        },

        /**
         * The number of unread notifications.
         */
        unreadNotificationsCount() {
            return 0;
        },

        /**
         * Determine if the user has any unread notifications.
         */
        hasUnreadAnnouncements() {
            return this.unreadAnnouncementsCount > 0;
        },
    },
};
